import { defineMessages } from 'react-intl';

export const additionalServicesMessages = defineMessages({
  itemIsUnpackedForYou: {
    id: 'additionalServices.itemIsUnpackedForYou',
    defaultMessage:
      '<bold>Artikel wordt voor je uitgepakt</bold> We pakken dit artikel voor je uit en nemen het verpakkingsmateriaal weer mee.',
  },
  itemIsPlaced: {
    id: 'additionalServices.itemIsPlaced',
    defaultMessage:
      '<bold>Artikel wordt meteen op de juiste plek gezet</bold> Onze bezorgers zetten dit artikel meteen op de gewenste plek neer.',
  },
  itemIsPlacedNotUnpack: {
    id: 'additionalServices.itemIslacedNotUnpack',
    defaultMessage:
      '<bold>Artikel wordt meteen op de juiste plek gezet</bold> Onze bezorgers zetten dit artikel meteen op de gewenste plek neer maar pakken deze niet uit.',
  },
  tvIsConnected: {
    id: 'additionalServices.tvIsConnected',
    defaultMessage:
      '<bold>TV wordt aangesloten & voet gemonteerd</bold> We sluiten de TV voor je aan op de elektriciteit en monteren de voet onder de TV. Geef bij de bezorger aan of je hier gebruik van wil maken.',
  },
  deliveryGroundFloor: {
    id: 'additionalServices.deliveryGroundFloor',
    defaultMessage:
      '<bold>Bezorging op (gelijkvloerse) begane grond</bold> Vanwege de artikelomvang en het gewicht plaatsen onze bezorgers dit artikel alleen op een gewenste plek op een gelijkvloerse begane grond of een verdieping bereikbaar met een geschikte lift.',
  },
});
